export default {
	comapny: 0,
	agent: 1,
	invester: 2,
	person: 3,
}